<!--
  `role="alertdialog"` with an assertive live region: this appears without being asked for and
  needs answering, which is exactly the case the role exists for. Join is first in the DOM so it
  is the first thing keyboard and screen-reader users reach.
-->
<div class="chat-ring" *ngIf="store.incomingCall() as call" role="alertdialog" aria-live="assertive" aria-label="Incoming call">
  <span class="chat-ring__icon"><i class="pi pi-video"></i></span>

  <div class="chat-ring__body">
    <span class="chat-ring__title">{{ call.caller }} is calling</span>
    <span class="chat-ring__sub">{{ call.label || call.provider_name }}</span>
  </div>

  <div class="chat-ring__actions">
    <button type="button" class="chat-ring__join" (click)="store.joinIncomingCall()">Join</button>
    <button type="button" class="chat-ring__ignore" (click)="store.dismissIncomingCall()">Ignore</button>
  </div>
</div>
